(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tripped-video-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var videos = document.querySelectorAll('.tripped-video-card__video[data-lazy-autoplay]');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        video.preload = 'auto';
        video.play().catch(function () {});
      });
      return;
    }

    var tryPlay = function (video) {
      var attempt = function () {
        video.play().catch(function () {});
      };
      attempt();
      video.addEventListener('canplay', attempt, { once: true });
    };

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (video.preload !== 'auto') video.preload = 'auto';
            tryPlay(video);
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px' }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
